module.exports = __webpack_public_path__ + "img/前端开发.b001516d.svg";